import createProposalsDraftPageTourSteps from "pages/proposals/CreateProposalsDraftPage.tour";
import listProposalsTourSteps from "./ListProposals.tour";
import createProposalTourSteps from "./forms/CreateProposalForm.tour";

// The "create your first proposal" tour runs across three pages. These keep the
// "Step X of Y" counter continuous from the proposals list through to sending.
export const FIRST_PROPOSAL_TOUR_CREATE_OFFSET = listProposalsTourSteps.length;
export const FIRST_PROPOSAL_TOUR_DRAFT_OFFSET =
  FIRST_PROPOSAL_TOUR_CREATE_OFFSET + createProposalTourSteps.length;
export const FIRST_PROPOSAL_TOUR_TOTAL_STEPS =
  FIRST_PROPOSAL_TOUR_DRAFT_OFFSET + createProposalsDraftPageTourSteps.length;
